import { render, staticRenderFns } from "./modalIndiceCorrecao.vue?vue&type=template&id=4b40bfff&scoped=true&"
import script from "./modalIndiceCorrecao.vue?vue&type=script&lang=js&"
export * from "./modalIndiceCorrecao.vue?vue&type=script&lang=js&"
import style0 from "./modalIndiceCorrecao.vue?vue&type=style&index=0&id=4b40bfff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b40bfff",
  null
  
)

export default component.exports